import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

const SUPPORTED_LANGUAGES = ["de", "en"];
export const DEFAULT_LANGUAGE = "de";
const STORAGE_KEY = "gem-locale";

@Injectable({ providedIn: "root" })
export class LanguageService {
  constructor(private translateService: TranslateService) {}

  /**
   * Explicitly chosen language, otherwise the first supported browser language, otherwise the default.
   * Does not persist anything: only an explicit user choice (setLanguage) is stored.
   */
  public getInitialLanguage(): string {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored;
    }

    const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const browserLanguage of browserLanguages) {
      const prefix = browserLanguage?.split("-")[0].toLowerCase();
      if (SUPPORTED_LANGUAGES.includes(prefix)) {
        return prefix;
      }
    }
    return DEFAULT_LANGUAGE;
  }

  public setLanguage(lang: string): void {
    this.translateService.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }

  public toggleLanguage(): void {
    this.setLanguage(this.translateService.currentLang === "de" ? "en" : "de");
  }
}
